export enum TableConfigSaveTrigger {
  Save = 'save',
  Recovery = 'recovery',
  Reset = 'reset'
}
